module.exports = __webpack_public_path__ + "img/pizza_white.7c39535b.jpg";